import type { Layer, Property } from 'web';

/** Normalizes saved scalar volumes without changing existing animation data. */
export function volumeProperty(volume: Property<number> | number | undefined): Property<number> {
  return typeof volume === 'number' || volume === undefined ? { type: 'constant', value: volume ?? 1 } : volume;
}

/** Audio fades affect gain; visual layer fades affect opacity. */
export function layerFadeProperty(layer: Layer): Property<number> {
  return layer.kind.type === 'audio' ? layer.kind.volume : (layer.opacity ?? { type: 'constant', value: 1 });
}
